import React, { useState } from "react";
import styled from "styled-components";
import { useSelector,useDispatch } from "react-redux";
import { selectMapZoomstate,setMapBounds } from "../../../features/maps/mapZoomSlice";
import Draggable from "react-draggable";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import 'react-best-tabs/dist/index.css';

const ProximityData = () => {
  const [visible, setVisible] = useState(true);
  const proxdata = useSelector(selectMapZoomstate);
  const hasData = proxdata && proxdata.extra;
  const dispatch = useDispatch();

  const rainfallData = proxdata?.extra?.rainfall || proxdata?.extra?.acurain || null;
  const windSpeedData = proxdata?.extra?.wind || null;
  const humidityData = proxdata?.extra?.humidity || null;
  const temperatureData = proxdata?.extra?.temperature || null;

  const isWindSpeedDataAvailable = windSpeedData !== null;
  const isHumidityDataAvailable = humidityData !== null;
  const isRainfallDataAvailable = rainfallData !== null;
  const isTemperatureDataAvailable = temperatureData !== null;

  let chartOptions = {};

  if (isWindSpeedDataAvailable) {
    const windSpeedCategories = ['200', '500', '700', '850', '925'];
    const meanWindSpeed = Object.values(windSpeedData).map(data => data?.mean_wind_speed || 0);
    const maxWindSpeed = Object.values(windSpeedData).map(data => data?.max_wind_speed || 0);
    const minWindSpeed = Object.values(windSpeedData).map(data => data?.min_wind_speed || 0);
    const stdDevWindSpeed = Object.values(windSpeedData).map(data => data?.std_dev_wind_speed || 0);

    chartOptions = {
      chart: { type: 'column', height: 350 },
      credits: { enabled: false },
      title: { text: 'Wind Speed at Different Altitudes' },
      xAxis: { categories: windSpeedCategories },
      yAxis: { title: { text: 'Wind Speed (m/s)' } },
      series: [
        { name: 'Mean Wind Speed', data: meanWindSpeed, color: '#FF6F61' },
        { name: 'Max Wind Speed', data: maxWindSpeed, color: '#FFB76B' },
        { name: 'Min Wind Speed', data: minWindSpeed, color: '#5B8F2B' },
        { name: 'Std Dev Wind Speed', data: stdDevWindSpeed, color: '#41A7D6' },
      ],
      legend: { enabled: true },
      tooltip: {
        pointFormatter: function () {
          return `${this.y.toFixed(2)} m/s`;
        },
      },
    };
  } else if (isHumidityDataAvailable) {
    const humidityCategories = ['200', '500', '700', '850', '925'];
    const meanHumidity = Object.values(humidityData).map(data => data?.mean_humidity || 0);
    const maxHumidity = Object.values(humidityData).map(data => data?.max_humidity || 0);
    const minHumidity = Object.values(humidityData).map(data => data?.min_humidity || 0);
    const stdDevHumidity = Object.values(humidityData).map(data => data?.std_dev_humidity || 0);

    chartOptions = {
      chart: { type: 'column', height: 350 },
      credits: { enabled: false },
      title: { text: 'Humidity at Different Altitudes' },
      xAxis: { categories: humidityCategories },
      yAxis: { title: { text: 'Humidity (%)' } },
      series: [
        { name: 'Mean Humidity', data: meanHumidity, color: '#FF6F61' },
        { name: 'Max Humidity', data: maxHumidity, color: '#FFB76B' },
        { name: 'Min Humidity', data: minHumidity, color: '#5B8F2B' },
        { name: 'Std Dev Humidity', data: stdDevHumidity, color: '#41A7D6' },
      ],
      legend: { enabled: true },
      tooltip: {
        pointFormatter: function () {
          return `${this.y.toFixed(2)} %`;
        },
      },
    };
  } else if (isTemperatureDataAvailable) {
    const temperatureCategories = ['200', '500', '700', '850', '925'];
    const meanTemps = Object.values(temperatureData).map(data => data?.mean_temperature || 0);
    const maxTemps = Object.values(temperatureData).map(data => data?.max_temperature || 0);
    const minTemps = Object.values(temperatureData).map(data => data?.min_temperature || 0);
    const stdDevTemps = Object.values(temperatureData).map(data => data?.std_dev_temperature || 0);

    chartOptions = {
      chart: { type: 'column', height: 350 },
      credits: { enabled: false },
      title: { text: 'Temperature Data at Different Altitudes' },
      xAxis: {
        categories: temperatureCategories,
        title: { text: 'Altitude (hPa)' },
      },
      yAxis: { title: { text: 'Temperature (°C)' } },
      series: [
        { name: 'Mean Temperature', data: meanTemps, color: '#FF6F61' },
        { name: 'Max Temperature', data: maxTemps, color: '#FFB76B' },
        { name: 'Min Temperature', data: minTemps, color: '#5B8F2B' },
        { name: 'Std Dev Temperature', data: stdDevTemps, color: '#41A7D6' },
      ],
      legend: { enabled: true },
      tooltip: {
        pointFormatter: function () {
          return `${this.y.toFixed(2)} °C`;
        },
      },
    };
  } else if (isRainfallDataAvailable) {
    const rainfallCategories = ['Total', 'Max', 'Min', 'Std Dev'];
    const rainfallValues = [
      rainfallData?.total_rainfall || 0,
      rainfallData?.max_rainfall || 0,
      rainfallData?.min_rainfall || 0,
      rainfallData?.std_dev_rainfall || 0,
    ];

    chartOptions = {
      chart: { type: 'column', height: 350 },
      credits: { enabled: false },
      title: { text: 'Rainfall Data' },
      xAxis: { categories: rainfallCategories },
      yAxis: { title: { text: 'Rainfall (mm)' } },
      series: [
        {
          name: 'Rainfall',
          data: rainfallValues,
          color: '#41A7D6',
        },
      ],
    };
  }

  const test=()=>{
      dispatch(setMapBounds({ kela:'no' }));
  }


  return (
    <Draggable>
      <Proximity>
        <div className="ProximityData-header">
          <h1> Data</h1>
          <span className="close-btn" onClick={() => test()}>×</span>
        </div>
        {hasData ? (
          <HighchartsReact highcharts={Highcharts} options={chartOptions} />
        ) : (
          <NoData>No data available</NoData>
        )}
      </Proximity>
    </Draggable>
  );
};

export default ProximityData;

// Styled Components
const Proximity = styled.div`
  position: absolute;
  top: 120px;
  left: 50px;
  width: 60%;
  height: 60%;
  background-color: #fff;
  z-index: 10000000000;
  overflow-y: auto;
  box-shadow: rgb(17 12 46 / 15%) 0px 48px 100px 0px;
  font-family: 'Nunito';
  font-size: 15px;
  cursor: pointer;
  border-radius: 8px;

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #f0f0f0;
  }

  ::-webkit-scrollbar-thumb {
    background: #6e7276;
  }

  h1 {
    font-size: 18px;
    font-weight: 500;
    font-family: 'Inter';
    color: #fff;
    margin: 0;
    padding: 10px 20px;
    flex: 1;
  }

  .ProximityData-header {
    background-color: #27557e;
    position: sticky;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 100;
    padding: 0 10px;
  }

  .close-btn {
    color: #fff;
    font-size: 24px;
    font-weight: bold;
    cursor: pointer;
    padding: 5px 10px;
    user-select: none;
  }

  @media screen and (max-width: 480px) {
    width: 80%;
    left: 10%;
    top: 15%;
  }
`;

const NoData = styled.div`
  font-size: 18px;
  font-family: 'Nunito';
  color: #333;
  text-align: center;
  padding: 20px;
`;
